import React, { Component } from 'react';

import AddEditNewModal from 'stocks/components/common/AddEditNewModal';
import DeleteModal from 'stocks/components/common/DeleteModal';
import Item from 'stocks/components/common/Item';

class CategoryItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newCategory: '',
      newEditableCategory: '',
      editCategoryModal: false,
      openAddNewCategoryModal: false,
      deleteModalCategory: false,
      disabledSaveCategory: true,
      category: [
        {
          id: 1,
          name: 'Color',
          numberOfProducts: '4',
        },
        {
          id: 2,
          name: 'Revenue',
          numberOfProducts: '234',
        },
        {
          id: 3,
          name: 'Backwash',
          numberOfProducts: '1025',
        },
      ],
    };
  }

  onDeleteCategory = () => {
    this.setState({ deleteModalCategory: true });
  };

  onEditCategory = () => {
    this.setState({ editCategoryModal: true });
  };

  closeEditCategoryModal = () => {
    this.setState({ editCategoryModal: false });
  };

  saveEditCategory = () => {};

  changeInputCategoryEdit = () => {};

  newEditableCategory = () => {};

  deleteCategory = () => {};

  closeModal = () => {
    this.setState({ deleteModalCategory: false });
  };

  closeAddNewModal = () => {
    this.setState({ openAddNewCategoryModal: false });
  };

  changeInputCategory = () => {};

  disabledSaveCategory = () => {};

  openAddNewModal = () => {
    this.setState({ openAddNewCategoryModal: true });
  };

  saveNewCategory = () => {};

  render() {
    // if (isFetching) {
    //   return (
    //     <div className="lds-wrap">
    //       <div className="lds-ring">
    //         <div />
    //         <div />
    //         <div />
    //         <div />
    //       </div>
    //     </div>
    //   );
    // } else if (category) {
    return (
      <div className="warp-container">
        <div className="items-header">
          <div>{this.props.title}</div>
          <span>Products assigned</span>
          <div className="btn-add-new">
            <button className="btn btn-violet" id="add-new-category" onClick={this.openAddNewModal}>
              Add new
            </button>
          </div>
        </div>

        <ul className="item-list">
          {this.state.category.map((cat) => (
            <Item
              key={cat.id}
              id={cat.id}
              name={cat.name}
              numberOfProducts={cat.numberOfProducts}
              editBtnText="Edit"
              deleteBtnText="Delete"
              onEdit={this.onEditCategory}
              onDelete={this.onDeleteCategory}
            />
          ))}
        </ul>
        {this.state.openAddNewCategoryModal && (
          <AddEditNewModal
            modalTitle="Add new category"
            label="Category name"
            onCancel={this.closeAddNewModal}
            onSave={this.saveNewCategory}
            changeInput={this.changeInputCategory}
            inputVal={this.state.newCategory}
            disabledSave={this.state.disabledSaveCategory}
          />
        )}
        {this.state.editCategoryModal && (
          <AddEditNewModal
            modalTitle="Edit category"
            label="Category name"
            onCancel={this.closeEditCategoryModal}
            onSave={this.saveEditCategory}
            changeInput={this.changeInputCategoryEdit}
            inputVal={this.state.newEditableCategory}
            disabledSave={this.state.disabledSaveCategory}
          />
        )}
        {this.state.deleteModalCategory && (
          <DeleteModal
            modalTitle="Delete category"
            text1="Any products in this category will be reassigned to the
            category Unknown. You can assign a new category in Stock Manager."
            text2="Are you sure you want to delete?"
            onCancel={this.closeModal}
            onDelete={this.deleteCategory}
          />
        )}
      </div>
    );
    // }
  }
}

export default CategoryItems;
